export default "__VITE_ASSET__BPgeSjUa__"